module.exports = __webpack_public_path__ + "frontend/images/gold/seeWorld@2.png?536c5dd47bfcd837f4061e7e8bea0731";